import React, { useState, useEffect } from 'react';
import { Grid, Box, Card, CardContent, Button, TextField } from '@mui/material';
import { format, subMonths, startOfMonth, toDate } from 'date-fns';
import { getCenterOfHopeDetail } from '../../scripts/api/webAppAnalyticsApi.js';
import CenterOfHopeDetailDto from '../../DTOs/WebAppAnalytics/CenterOfHopeDetailDto.js';
import DateRangeDto from '../../DTOs/shared/DateRangeDto.js';
import { message } from '../shared/Message.js';
import DataTable from './shared/DataTable.js';

function CenterOfHopeDetail() {
  const [centerOfHopeDetailDto, setCenterOfHopeDetailDto] = useState(new CenterOfHopeDetailDto());
  const [startDate, setStartDate] = useState(format(startOfMonth(subMonths(new Date(), 3)), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [fetchStartDate, setFetchStartDate] = useState(startDate);
  const [fetchEndDate, setFetchEndDate] = useState(endDate);

  const fetchData = async (start, end) => {
    const dateRangeDto = new DateRangeDto({
      startDate: toDate(new Date(start)).toISOString(),
      endDate: toDate(new Date(end)).toISOString(),
    });
    try {
      let result = await getCenterOfHopeDetail(JSON.stringify(dateRangeDto));
      setCenterOfHopeDetailDto(result);
    } catch (err) {
      message.error(err.message);
    }
  };

  useEffect(() => {
    fetchData(fetchStartDate, fetchEndDate);
  }, [fetchStartDate, fetchEndDate]);

  const handleFetchData = () => {
    setFetchStartDate(startDate);
    setFetchEndDate(endDate);
  };

  return (
    <Grid container spacing={3}>
      {/* Date Range and Fetch Button */}
      <Grid item xs={12}>
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFetchData}
                fullWidth
              >
                Refresh
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Grid>

      {/* Barriers Section */}
      <Grid item xs={12}>
        <Grid container spacing={3}>
          {/* New Barriers */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <DataTable
                  data={{
                    headers: ["Client", "Date", "Barrier"],
                    rows: centerOfHopeDetailDto.clientBarrierNew.map(b => [
                      b.client,
                      new Date(b.date).toLocaleDateString("en-US"),
                      b.barrier
                    ])
                  }}
                  title="New Client Barriers"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Removed Barriers */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <DataTable
                  data={{
                    headers: ["Client", "Date", "Barrier"],
                    rows: centerOfHopeDetailDto.clientBarrierRemoved.map(b => [
                      b.client,
                      new Date(b.date).toLocaleDateString("en-US"),
                      b.barrier
                    ])
                  }}
                  title="Removed Client Barriers"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* New Goals */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <DataTable
                  data={{
                    headers: ["Client", "Date", "Goal"],
                    rows: centerOfHopeDetailDto.clientGoalNew.map(b => [
                      b.client,
                      new Date(b.date).toLocaleDateString("en-US"),
                      b.goal
                    ])
                  }}
                  title="New Client Goals"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Removed Goals */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <DataTable
                  data={{
                    headers: ["Client", "Date", "Goal"],
                    rows: centerOfHopeDetailDto.clientGoalRemoved.map(b => [
                      b.client,
                      new Date(b.date).toLocaleDateString("en-US"),
                      b.goal
                    ])
                  }}
                  title="Removed Client Goals"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CenterOfHopeDetail;
